import { render, staticRenderFns } from "./bsp-dicts-cascader.vue?vue&type=template&id=5204a2f8&scoped=true&"
import script from "./bsp-dicts-cascader.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-cascader.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-cascader.vue?vue&type=style&index=0&id=5204a2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204a2f8",
  null
  
)

export default component.exports